const Steps = [
    "Basic information",
    "Event Information",
    "Contact Information",
    "Summary",
];

export default Steps;